import Vue from 'vue';
import App from './App.vue';
import router from './router';
import AWS from 'aws-sdk';
import store from './store';
import Amplify, * as AmplifyModules from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';
import { v4 as uuid } from 'uuid';

import resize from "vue-element-resize-detector";

// toast
import VueNotifications from 'vue-notifications';
import 'jquery';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

function toast({ title, message, type, timeout }) {
  if (type === VueNotifications.types.warn) type = 'warning';
  return toastr[type](message, title, {
    timeOut: timeout
  });
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};

Vue.use(VueNotifications, options);

Vue.use(AmplifyPlugin, AmplifyModules);

Vue.use(resize);

AWS.config.region = process.env.VUE_APP_AWS_REGION;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');

Amplify.configure({
  Auth: {
    oauth: {
      domain: process.env.VUE_APP_DOMAIN,
      scope: [
        'email',
        'openid',
        'aws.cognito.signin.user.admin',
        'profile_name'
      ],
      redirectSignIn: process.env.VUE_APP_REDIRECT,
      redirectSignOut: process.env.VUE_APP_SIGN_OUT,
      responseType: 'code'
    },
    userPoolId: process.env.VUE_APP_USER_POOL_ID,
    identityPoolId: process.env.VUE_APP_IDENTITY_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_CLIENT_ID,
    region: process.env.VUE_APP_AWS_REGION,
    mandatorySignIn: true
  },
  API: {
    endpoints: [
      {
        name: 'API',
        endpoint: process.env.VUE_APP_API_BASE,
        async custom_header() {
          try {
            const { idToken } = await AmplifyModules.Auth.currentSession();
            return {
              Authorization: idToken.jwtToken
            };
          } catch (e) {
            console.log(e);
            return {};
          }
        }
      }
    ]
  },
  Storage: {
    AWSS3: {
      bucket: process.env.VUE_APP_CONFIG_BUCKET,
      region: process.env.VUE_APP_AWS_REGION
    }
  },
  PubSub: {
    clientId: uuid()
  }
});
